import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import { httpOk, GET, POST, PUT } from 'helpers/api'

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [orderTypes, setOrdertTypes] = useState([])
	const [confirmationTypes, setConfirmationTypes] = useState([])
	const [externalCouriers, setExternalCouriers] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [showModal, setShowModal] = useState(false)

	async function searchWithFilter() {
		var filterUrl = "/order-type-subs"
		var urlParams = ""

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	async function createUpdate(e) {
		e.preventDefault()

		var response;
		if (selectedItem.id) {
			response = await PUT('/order-type-subs', selectedItem, { loader: true })
		} else {
			response = await POST('/order-type-subs', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			toggleModal()
			searchWithFilter()
		}
	}

	function toggleModal(bool = false, item = {}) {
		setSelectedItem(item)
		setShowModal(bool)
	}

	async function getOrderTypes() {
		const response = await GET('/helper/order-types')
		if (httpOk(response)) setOrdertTypes(response.data)
	}

	async function getConfirmationTypes() {
		const response = await GET('/helper/confirmation-types')
		if (httpOk(response)) setConfirmationTypes(response.data)
	}

	// Все службы бренда, а не только точки пользователя: подтип общий на бренд.
	// Отключённую службу выбрать нельзя, но если она уже стоит — показываем
	async function getExternalCouriers() {
		const response = await GET('/external-couriers')
		if (httpOk(response)) setExternalCouriers(response.data)
	}

	useEffect(() => {
		getOrderTypes()
		getConfirmationTypes()
		getExternalCouriers()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('order_types')}
				</h4>
				<div className="d-flex">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '18%' }}>{t('name2')}</th>
									<th style={{ 'width': '15%' }}>{t('type')}</th>
									<th style={{ 'width': '13%' }}>{t('confirmation_type')}</th>
									<th style={{ 'width': '24%' }}>{t('auto_external_courier')}</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('auto_confirm_short')}</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('auto_precheck_short')}</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('default')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td className="td-ellipsis">
											<span className="link-primary" style={{ 'cursor': 'pointer' }}
												onClick={() => toggleModal(true, item)}>{item.name}</span>
										</td>
										<td className="td-ellipsis">{item.order_type_name}</td>
										<td className="td-ellipsis">{item.confirmation_type_name}</td>
										<td className="td-ellipsis">{item.auto_external_courier_name}</td>
										<td className="text-center">
											{item.order_type_id !== 1 && (item.is_auto_confirmed
												? <span className="bg-primary bg-border" title={t('yes')}></span>
												: <span className="bg-danger bg-border" title={t('no')}></span>
											)}
										</td>
										<td className="text-center">
											{item.order_type_id !== 1 && (item.is_auto_precheck
												? <span className="bg-primary bg-border" title={t('yes')}></span>
												: <span className="bg-danger bg-border" title={t('no')}></span>
											)}
										</td>
										<td className="text-center">
											{item.is_default
												? <span className="bg-primary bg-border" title={t('yes')}></span>
												: <span className="bg-danger bg-border" title={t('no')}></span>
											}
										</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered
				dialogClassName="update-modal-width" onHide={() => toggleModal()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>

						<div className="form-group">
							<label>{t('order_types')}<span className="required-mark">*</span></label>
							<Select
								isDisabled={selectedItem.id}
								options={orderTypes}
								value={orderTypes.find(option => option.id === selectedItem.order_type_id)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'order_type_id': option.id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>

						{selectedItem.id &&
							<div className="form-group">
								<label>{t('confirmation_types')}</label>
								<Select
									isClearable
									options={confirmationTypes}
									value={confirmationTypes.find(option => option.id === selectedItem.confirmation_type_id)}
									onChange={(option) => setSelectedItem({ ...selectedItem, 'confirmation_type_id': option ? option.id : null })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
						}

						{selectedItem.order_type_id === 3 &&
							<div className="form-group">
								<label>{t('auto_external_courier')}</label>
								<Select
									isClearable
									options={externalCouriers.filter(option => option.is_active)}
									value={externalCouriers.find(option => option.id === selectedItem.auto_external_courier_id) || null}
									onChange={(option) => setSelectedItem({ ...selectedItem, 'auto_external_courier_id': option ? option.id : null })}
									placeholder={t('auto_external_courier_off')}
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
								<small className="text-muted">{t('auto_external_courier_hint')}</small>
							</div>
						}

						{selectedItem.order_type_id !== 1 &&
							<div className="d-flex justify-content-between mb-2">
								<div className="fw-500 vertical-center">
									{t('auto_cheque_confirmation')}
									<div className="text-muted fs-12">{t('auto_confirm_order_type_hint')}</div>
								</div>
								<div className="form-check form-switch form-switch-lg">
									<input type="checkbox" className="form-check-input"
										name="is_auto_confirmed"
										checked={selectedItem.is_auto_confirmed ? true : false}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'is_auto_confirmed': e.target.checked })} />
								</div>
							</div>
						}

						{selectedItem.order_type_id !== 1 &&
							<div className="d-flex justify-content-between mb-2">
								<div className="fw-500 vertical-center">
									{t('auto_precheck_print')}
									<div className="text-muted fs-12">{t('auto_precheck_print_hint')}</div>
								</div>
								<div className="form-check form-switch form-switch-lg">
									<input type="checkbox" className="form-check-input"
										name="is_auto_precheck"
										checked={selectedItem.is_auto_precheck ? true : false}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'is_auto_precheck': e.target.checked })} />
								</div>
							</div>
						}

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}
		</>
	)
}

export default Index